import React from 'react'
import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'

import { SelectField } from '.'

const query = gql`
  query {
    customers {
      id
      cod
      name
    }
  }
`
const withQuery = graphql(query)

const CustomerSelectField = compose(
  withQuery,
  withProps(({ data: { loading, customers = [] } }) => {
    const options = customers.map(rec => ({
      value: rec.id,
      label: rec.name
    }))
    return {
      isLoading: loading,
      options
    }
  })
)(SelectField)

export default props => (
  <React.Fragment>
    <FormControl fullWidth>
      <InputLabel shrink>Cliente</InputLabel>
    </FormControl>
    <CustomerSelectField {...props} />
  </React.Fragment>
)
